import { BaseRoutes } from './base.routes.constants';

export class AntecipacaoValidationRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
